import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { LOGO_ICON } from "@/lib/brand";

/**
 * Abschließender Handlungsaufruf einer Unterseite. Bewusst nah am CTA der
 * Startseite gehalten, damit das Seitenende überall gleich klingt.
 */
export const CTABand = ({
  id = "cta",
  title,
  accent,
  tail,
  lead,
  primary,
  secondary,
}) => (
  <section id={id} data-testid="cta-band" className="relative py-24 lg:py-32">
    <div className="px-6 md:px-10 lg:px-16">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] border border-white/10 backdrop-blur-xl px-8 py-16 md:px-16 md:py-20 text-center">
          <div className="pointer-events-none absolute inset-0 -z-10">
            <div className="absolute -top-20 left-1/4 w-96 h-96 rounded-full bg-brand-orange/25 blur-[130px]" />
            <div className="absolute -bottom-24 right-1/4 w-96 h-96 rounded-full bg-brand-blue/25 blur-[130px]" />
          </div>

          <img
            src={LOGO_ICON}
            alt=""
            aria-hidden="true"
            className="mx-auto w-14 h-14 object-contain mb-8 animate-float drop-shadow-[0_0_20px_rgba(255,107,0,0.5)]"
          />

          <h2 className="font-display font-black tracking-tighter text-3xl md:text-5xl lg:text-6xl leading-[0.98] max-w-3xl mx-auto">
            {title}
            {accent && <span className="gradient-text">{accent}</span>}
            {tail}
          </h2>

          {lead && (
            <p className="mt-6 max-w-xl mx-auto text-base md:text-lg leading-relaxed text-white/60">
              {lead}
            </p>
          )}

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            {primary && (
              <Link
                to={primary.to}
                data-testid="cta-band-primary"
                className="group inline-flex items-center gap-2 rounded-full px-8 py-4 text-sm font-bold text-white bg-gradient-to-r from-brand-orange to-brand-blue shadow-[0_0_40px_-6px_rgba(255,107,0,0.7)] hover:shadow-[0_0_50px_-4px_rgba(0,122,255,0.8)] hover:scale-[1.04] transition-all duration-300"
              >
                {primary.label}
                <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform duration-300" />
              </Link>
            )}
            {secondary && (
              <Link
                to={secondary.to}
                data-testid="cta-band-secondary"
                className="inline-flex items-center gap-2 rounded-full px-7 py-4 text-sm font-semibold text-white/85 border border-white/15 bg-white/[0.02] hover:bg-white/[0.06] hover:text-white transition-all duration-300"
              >
                {secondary.label}
              </Link>
            )}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
